import Container from './styled/Container'

const SelectListIcon = Container

export default /** @type any */(SelectListIcon)
